import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import immutable from 'immutable';

class List extends React.Component {

	flattenTree(nodes, level = 0, parentCollapsed = false) {
		let rows = [];
		nodes.forEach(item => {
			item.collapsed = this.props.collapsed.indexOf(item.id) > -1;
			item.hide = parentCollapsed;
			item.level = level;
			rows.push(item);
			if (item.childs.length) {
				let subrows = this.flattenTree(item.childs, level+1, item.collapsed || item.hide);
				rows = rows.concat(subrows);
			}
		});
		return rows;
	}

	componentDidMount() {
		const id = this.props.value && this.props.value.get('id');
		if (id) {
			ReactDOM.findDOMNode(this.refs[id]).focus();
		}
	}

	renderOption (item, index) {
		let optionClass = classNames({
			'Dropdown-option': true,
			'is-selected': this.props.value && item.id == this.props.value.get('id'),
			'hide': item.hide
		});

		let ico;
		const collapsed = item.collapsed;
		if (item.childs.length) {
			if (!collapsed) {
				ico = <span onClick={(e) => this.props.onCollapse(e, true, item.id)} style={{width:8,cursor:'pointer'}} className="fa fa-caret-down position-left"/>
			}
			else {
				ico = <span onClick={(e) => this.props.onCollapse(e, false, item.id)} style={{paddingLeft:3, width:8,cursor:'pointer'}} className="fa fa-caret-right position-left"/>
			}
		}
		else {
			ico = <span className="fa" style={{marginRight: 16}} />
		}

		return <div key={item.id}
					ref={item.id}
					style={{paddingLeft: item.level * 10 + 10}}
					className={optionClass}
					tabIndex={index}
					onClick={() => this.props.onSelect(immutable.Map({id: item.id, title: item.title}))}>
			{ico}
			{item.title}
		</div>
	}

	render() {
		const rows = this.flattenTree(this.props.tree).map((item, index) => {
			return this.renderOption(item, index);
		});
		return rows.length ? <div>{rows}</div> : <div className='Dropdown-noresults'>Žádné záznamy k zobrazení</div>;
	}

}


export default class TreePicker extends React.Component {

	static defaultProps = {
		controlClassName: 'Dropdown-control',
		menuClassName: 'Dropdown-menu',
		width: 'auto',
		dropdownWidth: '100%'
	};

	constructor(props) {
		super(props);
		this.state = {
			value: props.value,
			isOpen: false,
			collapsed: [],
			loaded: !!props.tree,
			tree: props.tree,
			pending: false
		};
		this.mounted = true;
		this.handleDocumentClick = this.handleDocumentClick.bind(this);
	}

	componentWillReceiveProps(newProps) {
		if (newProps.value !== this.state.value) {
			this.setState({value: newProps.value});
		}
	}

	componentDidMount() {
		document.addEventListener('click', this.handleDocumentClick, false);
	}

	componentWillUnmount() {
		this.mounted = false;
		document.removeEventListener('click', this.handleDocumentClick, false);
	}

	handleMouseDown(event) {

		if (event.type == 'mousedown' && event.button !== 0) return;
		event.stopPropagation();
		event.preventDefault();

		this.setState({
			isOpen: !this.state.isOpen
		}, () => {
			if (this.state.isOpen) {
				this.load();
			}
		});
	}

	setValue(option) {
		let newState = {
			value: option,
			isOpen: false
		};
		this.fireChangeEvent(newState);
		this.setState(newState);
	}

	fireChangeEvent(newState) {
		if (newState.value !== this.state.value) {
			if (this.props.onChange) {
				this.props.onChange(newState.value);
			}
			if (this.props.onBlur) {
				this.props.onBlur(newState.value);
			}
		}
	}

	handleCollapse(e, collapse, id) {
		e.stopPropagation();

		const i = this.state.collapsed.indexOf(id);
		if (collapse) {
			if (i == -1) {
				this.state.collapsed.push(id);
			}
		}
		else {
			if (i != -1) {
				this.state.collapsed.splice(i, 1);
			}
		}
		this.setState({collaped: this.state.collapsed});
	}



	buildMenu() {
		if (this.state.loaded) {
			return <List tree={this.state.tree}
						 collapsed={this.state.collapsed}
						 onCollapse={(e, status, item) => this.handleCollapse(e, status, item)}
						 onSelect={(val) => this.setValue(val)}
						 value={this.state.value}
				/>;
		}
		else {
			return (
				<div className='Dropdown-noresults'>
					Načítám data...
				</div>
			);
		}
	}

	handleDocumentClick(event) {
		if(this.mounted) {
			if (!ReactDOM.findDOMNode(this).contains(event.target)) {
				this.setState({isOpen:false});
			}
		}
	}

	load() {
		if (!this.state.loaded) {
			this.setState({
				pending: true
			});
			this.props.getData((data) => {
				this.setState({
					loaded: true,
					tree: data,
					pending: false
				});
			});
		}
	}

	handleReset(e) {
		e.stopPropagation();
		this.setValue(null);
	}

	render() {
		const { controlClassName, menuClassName } = this.props;
		let value = (<div>
			{this.state.value ? <div><span className="reset icon-cross" onClick={e => this.handleReset(e)}></span>{this.state.value.get('title')}</div> : <span className='placeholder'>{this.props.placeholder}</span>}
		</div>);
		let menu = this.state.isOpen ? <div className={menuClassName} style={{width: this.props.dropdownWidth}}>{this.buildMenu()}</div> : null;

		let dropdownClass = classNames({
			'Dropdown': true,
			'is-open': this.state.isOpen
		});

		return (
			<div className={dropdownClass} style={{width: this.props.width}}>
				<div className={controlClassName} onClick={this.handleMouseDown.bind(this)}>
					{value}
					<span className='Dropdown-arrow' />
				</div>
				{menu}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-inputs/TreePicker.js